// tslint:disable-next-line:no-unused-variable
import * as React from 'react';

import connectState from '../../../../../utils/connect_state';
import { createComponentContainer } from '../../../../../utils/hoc';
import { resetSubscriptionForm, submitSubscriptionForm } from '../actions/index';
import { IComponentState } from '../index';
import SubscriptionForm, { ISubscriptionFormGeneralProps, ISubscriptionFormProps } from './subscription_form';

export interface ISubmitForm {
  // tslint:disable-next-line:no-any
  (email: string): Promise<any>;
}

export interface ISubscriptionFormContainerProps extends ISubscriptionFormGeneralProps {
  onSubmit: ISubmitForm;
  successCallback?: () => void;
}

export default createComponentContainer<ISubscriptionFormContainerProps>()
  .pipe(
    connectState<IComponentState, ISubscriptionFormContainerProps, ISubscriptionFormProps>(
      (state, dispatch, parentProps) => ({
        email: parentProps.email,
        inputStyle: parentProps.inputStyle,
        formStyle: parentProps.formStyle,
        buttonTheme: parentProps.buttonTheme,
        buttonText: parentProps.buttonText,
        allowRetry: parentProps.allowRetry,
        userIsAuthenticated: parentProps.userIsAuthenticated,
        onSubmit: (email: string) => {
          dispatch(submitSubscriptionForm(parentProps.onSubmit, email, parentProps.successCallback));
        },
        onReset: () => {
          dispatch(resetSubscriptionForm({}));
        },
        status: state.form.status,
        successMessage: parentProps.successMessage,
        errorText: state.form.errorText,
      })
    )
  )
  .build(SubscriptionForm);



// WEBPACK FOOTER //
// ./src/bundles/common/components/subscription_form/component/subscription_form_container.tsx